/* tslint:disable */
/* eslint-disable */
/**
 * My App API
 * My App API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Option,
    OptionFromJSON,
    OptionFromJSONTyped,
    OptionToJSON,
} from './';

/**
 * 
 * @export
 * @interface EducationCertificateCategory
 */
export interface EducationCertificateCategory {
    /**
     * 
     * @type {number}
     * @memberof EducationCertificateCategory
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof EducationCertificateCategory
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof EducationCertificateCategory
     */
    nameJa: string;
    /**
     * 
     * @type {Option}
     * @memberof EducationCertificateCategory
     */
    programType: Option;
    /**
     * 
     * @type {Array<number>}
     * @memberof EducationCertificateCategory
     */
    types: Array<number>;
}

export function EducationCertificateCategoryFromJSON(json: any): EducationCertificateCategory {
    return EducationCertificateCategoryFromJSONTyped(json, false);
}

export function EducationCertificateCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): EducationCertificateCategory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'nameJa': json['nameJa'],
        'programType': OptionFromJSON(json['programType']),
        'types': json['types'],
    };
}

export function EducationCertificateCategoryToJSON(value?: EducationCertificateCategory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'nameJa': value.nameJa,
        'programType': OptionToJSON(value.programType),
        'types': value.types,
    };
}


